import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import DetailTop from "../../../component/atoms/layout/detail/detailTop";
import GoBack from "../../../component/molecules/goBack";
import DelBtn from "../../../component/atoms/button/delBtn";
import DetailPageTitle from "../../../component/atoms/text/detail/detailPageTitle";
import DetailPageForm from "../../../component/atoms/layout/detail/detailPageForm";
import DetailFormTitle from "../../../component/atoms/text/detail/detailFormTitle";
import DetailFormText from "../../../component/atoms/text/detail/detailFormText";
import DetailPage from "../../../component/atoms/layout/detail/detailPage";
import { errorHandler } from "../../../util/errorHandler";
import moment from "moment";
import Modal from "../../../component/templates/Modal";
import { modalMsg } from "../../../util/modalMsg";
import { toast } from "react-toastify";
import { toastMsg } from "../../../util/toastMsg";
import ConsultingApi from "../../../api/consulting.api";
import { fileDownload } from "../../../util/fileManagement";

const RequiredFormDetail = () => {
  const navigate = useNavigate();
  let { id } = useParams();

  // ----- 정보 가져오기
  const [formDetail, setFormDetail] = useState({});

  useEffect(() => {
    getConsultingInfo();
  }, []);

  const getConsultingInfo = async () => {
    try {
      const response = (await ConsultingApi.getByPriorFormId(id)).data.data
        .content;

      setFormDetail(response);
    } catch (error) {
      errorHandler(error);
    }
  };

  // ----- 삭제
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const deleteFunc = async () => {
    try {
      const data = {
        ids: [id],
      };
      await ConsultingApi.deleteConsulting(data);
      toast(toastMsg.delete);
      setDeleteModalOpen(false);
      navigate(-1);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        <DetailPageLayout>
          <DetailTop>
            <GoBack />
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <DelBtn onClick={() => setDeleteModalOpen(true)} />
            </div>
          </DetailTop>

          <DetailPage>
            <DetailPageTitle>상세보기</DetailPageTitle>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "20px" }}
            >
              <DetailPageForm>
                <DetailFormTitle>제출일</DetailFormTitle>
                <DetailFormText>
                  {formDetail.submitDate
                    ? moment(formDetail.submitDate).format("YYYY/MM/DD")
                    : ""}
                </DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>토스 신용점수 캡쳐화면</DetailFormTitle>
                <DetailFormText
                  style={{ textDecoration: "underline", cursor: "pointer" }}
                  onClick={() => {
                    fileDownload(
                      formDetail.fileServerFileName1,
                      formDetail.fileOriginFileName1
                    );
                  }}
                >
                  {formDetail.fileOriginFileName1}
                </DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>
                  토스 신용점수 캡쳐화면 아래
                  <br />
                  대출상세내역
                </DetailFormTitle>
                <DetailFormText
                  style={{ textDecoration: "underline", cursor: "pointer" }}
                  onClick={() => {
                    fileDownload(
                      formDetail.fileServerFileName2,
                      formDetail.fileOriginFileName2
                    );
                  }}
                >
                  {formDetail.fileOriginFileName2}
                </DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>보유부동산 및 가계상황</DetailFormTitle>
                <DetailFormText
                  style={{ textDecoration: "underline", cursor: "pointer" }}
                  onClick={() => {
                    fileDownload(
                      formDetail.fileServerFileName3,
                      formDetail.fileOriginFileName3
                    );
                  }}
                >
                  {formDetail.fileOriginFileName3}
                </DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>사업자 등록증 (사업자일 경우)</DetailFormTitle>
                <DetailFormText
                  style={{ textDecoration: "underline", cursor: "pointer" }}
                  onClick={() => {
                    fileDownload(
                      formDetail.fileServerFileName4,
                      formDetail.fileOriginFileName4
                    );
                  }}
                >
                  {formDetail.fileOriginFileName4}
                </DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>
                  최근 결산기 부가가치세
                  <br />
                  과세표준증명원 (사업자일 경우)
                </DetailFormTitle>
                <DetailFormText
                  style={{ textDecoration: "underline", cursor: "pointer" }}
                  onClick={() => {
                    fileDownload(
                      formDetail.fileServerFileName5,
                      formDetail.fileOriginFileName5
                    );
                  }}
                >
                  {formDetail.fileOriginFileName5}
                </DetailFormText>
              </DetailPageForm>
            </div>
          </DetailPage>
          <DetailPage>
            <DetailPageTitle>사전 상담 내용</DetailPageTitle>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "20px" }}
            >
              <DetailPageForm>
                <DetailFormTitle>아이디</DetailFormTitle>
                <DetailFormText>{formDetail.member?.account}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>제출일</DetailFormTitle>
                <DetailFormText>
                  {moment(formDetail.createdAt).format("YYYY/MM/DD")}
                </DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>이름</DetailFormTitle>
                <DetailFormText>{formDetail.name}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>연락처</DetailFormTitle>
                <DetailFormText>{formDetail.phoneNumber}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>생년월일</DetailFormTitle>
                <DetailFormText>{formDetail.birth}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>현재 상황</DetailFormTitle>
                <DetailFormText>{formDetail.currentStatus}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>상담이 필요한 부분</DetailFormTitle>
                <DetailFormText>{formDetail.necessaryPart}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>
                  부동산 및 대출 관련
                  <br />
                  평소 궁금했던 점 3가지
                </DetailFormTitle>
                <DetailFormText>{formDetail.curiousPoint}</DetailFormText>
              </DetailPageForm>
            </div>
          </DetailPage>
        </DetailPageLayout>
      </MainLayout>

      {deleteModalOpen ? (
        <Modal
          negative
          title={modalMsg.delete?.title}
          text={modalMsg.delete?.content}
          btnTitle={"삭제하기"}
          setModalOpen={setDeleteModalOpen}
          onClick={() => {
            deleteFunc();
          }}
        />
      ) : null}
    </>
  );
};

export default RequiredFormDetail;
